import _sfc_main from "./index83.js";
/* empty css        */
import _export_sfc from "./index63.js";
const ReceiptCreditNoteLocalizationMe = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-544395f8"]]);
export {
  ReceiptCreditNoteLocalizationMe as default
};
//# sourceMappingURL=index27.js.map
